import { allColors, FoodsIcon, WhiteBox } from "@foodpilot/foods";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ValidatedState, ValidatedTag } from "../../ValidatedTag";
import { CircularProgress } from "src/components/CircularProgress";
import { Link } from "react-router";

type SummaryBlockOverviewProps = {
    title: {
        label: string;
        tag?: ValidatedState;
    };
    completion: {
        progress: number | undefined;
        label: string;
        info: string;
        colorIndex: keyof typeof allColors;
    };
    isLocked: boolean;
    canViewSsq: boolean;
    link: {
        goTo: string | undefined;
    };
};
export const SummaryBlockOverview = (props: SummaryBlockOverviewProps) => {
    const { title, completion, link, isLocked, canViewSsq } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    const datavizColor = theme.custom.dataviz.colorsWithExtra[completion.colorIndex];

    const goToLabel =
        isLocked ? t("questionnaire.consult")
        : completion.progress === 100 ? t("questionnaire.complete")
        : t("questionnaire.modify");
    return (
        <WhiteBox
            sx={{
                gridRow: "span 3",
                display: "grid",
                gridTemplateRows: "subgrid",
                padding: theme.spacing(2),
            }}
        >
            <Stack
                flexDirection={"row"}
                gap={theme.spacing(2)}
                justifyContent={"space-between"}
                alignItems={"center"}
                alignSelf={"start"}
            >
                <Stack flexDirection="row" gap={theme.spacing(2)}>
                    <Typography variant="h4" alignSelf={"center"} sx={{ overflowWrap: "anywhere" }}>
                        {title.label}
                    </Typography>
                </Stack>
                {title.tag === "validated" && <ValidatedTag state={title.tag} />}
            </Stack>
            <Box
                sx={{
                    width: "100%",
                    alignSelf: "start",
                    backgroundColor: datavizColor.variant[100],
                    borderRadius: "8px",
                }}
            >
                <Stack flexDirection="row" padding={theme.spacing(1)} gap={theme.spacing(1.5)} alignItems={"center"}>
                    <CircularProgress progress={completion.progress ?? 0} color={datavizColor.main} />
                    <Stack sx={{ ml: theme.spacing(8) }}>
                        <Typography variant="h3">{completion.label}</Typography>
                        <Typography variant="body">{completion.info}</Typography>
                    </Stack>
                </Stack>
            </Box>
            {link.goTo === undefined || !canViewSsq ?
                <></>
            :   <Link to={link.goTo}>
                    <Button
                        variant="ternary"
                        endIcon={<FoodsIcon size={2} icon="arrowRight" />}
                        sx={{ width: "100%", textAlign: "justify", color: theme.custom.grey[2800] }}
                    >
                        <Typography variant="body-bold" sx={{ width: "100%" }}>
                            {goToLabel}
                        </Typography>
                    </Button>
                </Link>
            }
        </WhiteBox>
    );
};
